import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=fff8554a&scoped=true&lang=pug&"
import script from "./providers.vue?vue&type=script&lang=js&"
export * from "./providers.vue?vue&type=script&lang=js&"
import style0 from "./providers.vue?vue&type=style&index=0&id=fff8554a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff8554a",
  null
  
)

/* custom blocks */
import block0 from "./providers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFiltersFilter: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/filters/filter.vue').default})
